<script lang="ts">
	import type { Snippet } from 'svelte';

	interface Props {
		anchor: string;
		active?: boolean;
		children: Snippet;
	}

	let { anchor, active = false, children }: Props = $props();

	let scaleOrigin = $state('origin-left');
	let previousActive = $state(active);

	$effect(() => {
		if (active !== previousActive) {
			scaleOrigin = active ? 'origin-left' : 'origin-right';
			previousActive = active;
		}
	});
</script>

<div
	role="none"
	class={[
		'group flex flex-col whitespace-nowrap',
		{ 'text-green-2': active, 'text-brown-2': !active }
	]}
	onmouseenter={() => (scaleOrigin = 'origin-left')}
	onmouseleave={() => (scaleOrigin = 'origin-right')}
>
	<a href="#{anchor}" class="mt-2 pb-1 text-[16px]/[140%] lg:text-[18px]/[140%]">
		{@render children()}
	</a>
	<div
		class={[
			'h-[2px] w-full',
			scaleOrigin,
			{
				'scale-100 bg-green-2': active,
				'scale-0 transform-gpu bg-brown-2 duration-400 ease-in-out lg:group-hover:scale-100':
					!active,
				'transition-transform': !active || previousActive
			}
		]}
		ontransitionend={() => (scaleOrigin = 'origin-left')}
	></div>
</div>
